export default __webpack_public_path__ + "static/media/roboto-latin-100italic.7f839a86.woff2";